( () => {
	const COUNTRY_TO_CURRENCY: Record< string, string > = {
		us: 'USD',
		eu: 'EUR',
		uk: 'GBP',
		cz: 'CZK',
	};
	const CURRENCY_SYMBOL: Record< string, { symbol: string; position: 'before' | 'after' } > = {
		USD: {
			symbol: '$',
			position: 'before',
		},
		EUR: {
			symbol: '€',
			position: 'before',
		},
		GBP: {
			symbol: '£',
			position: 'before',
		},
		CZK: {
			symbol: 'Kč',
			position: 'after',
		},
	};

	const switchers = document.querySelectorAll( '.wp-block-phrase-com-pricing-currency-switcher' );
	if ( ! switchers.length ) {
		return;
	}

	const amounts = document.querySelectorAll< HTMLDivElement >(
		'.wp-block-phrase-com-pricing-data-price__amount'
	);
	if ( ! amounts.length ) {
		return;
	}

	// Update the active state of the currency switcher.
	const updateToggle = ( currency: string ) => {
		switchers.forEach( ( switcher ) => {
			switcher
				.querySelector< HTMLAnchorElement >( 'a[aria-checked="true"]' )
				?.setAttribute( 'aria-checked', 'false' );

			switcher
				.querySelector< HTMLAnchorElement >( `a[data-currency="${ currency }"]` )
				?.setAttribute( 'aria-checked', 'true' );
		} );
	};

	// Change pricing and currency symbol.
	const updatePrices = ( currency: string ) => {
		const currencyField = `price${ currency[ 0 ] + currency.slice( 1 ).toLocaleLowerCase() }`;
		const currencySymbol = CURRENCY_SYMBOL[ currency ];

		if ( currencySymbol.position === 'before' ) {
			document.body.style.setProperty(
				'--pricing-currency-symbol-before',
				`"${ currencySymbol.symbol } "`
			);
			document.body.style.setProperty( '--pricing-currency-symbol-after', `""` );
		} else {
			document.body.style.setProperty(
				'--pricing-currency-symbol-after',
				`" ${ currencySymbol.symbol }"`
			);
			document.body.style.setProperty( '--pricing-currency-symbol-before', `""` );
		}

		amounts.forEach( ( amount ) => {
			const amountData = amount.dataset[ currencyField ];
			if ( amountData ) {
				amount.innerText = amountData;
			}
		} );
	};

	// Handler for when a country is switched (legacy support).
	const onCountrySwitch = ( countryCode: string ) => {
		countryCode = countryCode.toLowerCase();
		onCurrencySwitch( COUNTRY_TO_CURRENCY[ countryCode ] ?? 'USD' );
	};

	// Handler for when a currency is switched.
	const onCurrencySwitch = ( currency: string ) => {
		updateToggle( currency );
		updatePrices( currency );

		try {
			localStorage.setItem( 'currency', currency );
		} catch {}
	};

	// Fetch geolocation data.
	const fetchGeolocationData = async () => {
		const response = await fetch( '/wp-json/phrase/v1/ip-geolocation', {
			method: 'POST',
			headers: {
				Accept: 'application/json',
			},
		} );
		if ( ! response.ok ) {
			throw new Error( 'Failed to fetch geolocation data.' );
		}
		return await response.json();
	};

	switchers.forEach( ( switcher ) => {
		const links = switcher.querySelectorAll( 'a' );

		links.forEach( ( link ) => {
			link.addEventListener( 'click', ( event ) => {
				event.preventDefault();

				const isChecked = 'true' === link.getAttribute( 'aria-checked' );
				if ( isChecked ) {
					return;
				}

				const currency = link.dataset.currency || 'USD';
				const country = link.dataset.country || 'us';

				onCurrencySwitch( currency );

				// Update browser URL.
				const location = new URL( document.location.href );
				location.searchParams.set( 'currency', country );
				window.history.replaceState( null, '', location.toString() );
			} );
		} );
	} );

	// Set the initial state.

	// Legacy way to support old URL parameters.
	const countryCodeFromUrl = new URL( document.location.href ).searchParams.get( 'currency' );
	if ( countryCodeFromUrl ) {
		onCountrySwitch( countryCodeFromUrl );
		return;
	}

	// Check for previous currency selection.
	const currencyFromLocalStorage = localStorage.getItem( 'currency' );
	if ( currencyFromLocalStorage ) {
		onCurrencySwitch( currencyFromLocalStorage );
		return;
	}

	// Get currency based on IP geolocation.
	fetchGeolocationData().then( ( data ) => {
		const { currency } = data;
		onCurrencySwitch( currency );
	} );
} )();
